import type { ReactNode } from "react";

type TagTone = "neutral" | "primary" | "accent" | "secondary" | "outline";

interface TagProps {
  children: ReactNode;
  tone?: TagTone;
  icon?: string;
  className?: string;
}

const toneClass: Record<TagTone, string> = {
  neutral: "bg-background-100 text-foreground-700 border-background-200",
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  outline: "bg-transparent text-foreground-600 border-background-300",
};

export default function Tag({ children, tone = "neutral", icon, className = "" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium leading-none ${toneClass[tone]} ${className}`}
    >
      {icon ? (
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className={`${icon} text-[13px]`} aria-hidden="true" />
        </span>
      ) : null}
      {children}
    </span>
  );
}